/**
 * Where grades are read and a term is closed out.
 *
 * The per-student grid is the working view and leads. Gradebook shape is set on
 * the course by an administrator, so it follows underneath as reference and as
 * the place term finalization lives.
 */
import { useOutletContext, useParams } from 'react-router-dom';
import GradebookGrid from '../GradebookGrid';
import GradebookManagementSection from '../GradebookManagementSection';
import type { ClassDetailContext } from '../classDetailTypes';

function ClassGradesPage() {
  const { schoolSlug, yearSlug, courseSlug } = useParams();
  const { offering, isAdmin, refetch } = useOutletContext<ClassDetailContext>();

  return (
    <div className="space-y-4">
      <GradebookGrid
        classOfferingId={offering.id}
        gradebooks={offering.gradebooks ?? []}
        assignments={offering.assignments ?? []}
        onChanged={() => refetch()}
      />

      <GradebookManagementSection
        classOfferingId={offering.id}
        gradebooks={offering.gradebooks ?? []}
        canManage={isAdmin}
        courseGradebooksPath={`/app/${schoolSlug}/years/${yearSlug}/courses/${courseSlug}`}
        onChanged={() => refetch()}
      />
    </div>
  );
}

export default ClassGradesPage;
